import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { AuthContext } from "context";
import { createMRTColumnHelper } from 'material-react-table';
import toast from 'react-hot-toast';
import MDAlert from "../../components/MDAlert";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import GenericTable from "../genericTable.js";

function ManagmentSecurityAreaSupplierAdmin() {

      const authContext = useContext(AuthContext);
      const {areaName,idArea} = useParams();
      const [aree, setAree] = useState([]);
      const [areaSelect,setAreaSelect] = useState(localStorage.getItem("areaSelected"));
      const [showSideBar,setShowSideBar] = useState(false);
      const navigate = useNavigate();
      const location = useLocation();
      const [data, setData] = useState([])

      const handleSetNotification = (msg, severityType) => {
        if (severityType === 'success') {
          toast.success(msg, {id: 'managment-security-area-supplier-admin-toast'});
        } else {
          toast.error(msg, {id: 'managment-security-area-supplier-admin-toast'});
        }
      };

      function fetchData(){
           apiService.get('/suppliers-management/', { area_id: idArea}, {})
              .then(data => {
                setData(data);
              })
              .catch(error => handleSetNotification("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #0901846038930",'error'));
      }

      useEffect(() => {
         fetchData()
      }, [])

      const columnHelper = createMRTColumnHelper();


      const columns = [
        columnHelper.accessor('name', {
          header: 'Nome',
          size: 120,
        }),
        columnHelper.accessor('address', {
          header: 'Fornitori',
          size: 120,
          Cell: ({ row }) => (
            <MDButton
              onClick={() => navigate("/security-document-supplier-admin/"+row.original.id+"/"+row.original.name+"/"+idArea+"/"+areaName)}
              size="small"
            > Vedi Documenti </MDButton>
          )
        }),

      ];

      return (
        <DashboardLayout>
          { authContext.hasAuth("VIEW_SECURITY_MANAGMENT") ?
          <>
            <DashboardNavbar/>
            <MDBox pt={6} pb={3}>
              <MDTypography variant="h6" color="black">
                SICUREZZA FORNITORI {areaName.toUpperCase()}
              </MDTypography>
            </MDBox>
            <GenericTable authModelName="SECURITY_MANAGMENT" data={data} columns={columns} disableButton={true}/>
            </>
            :
            <MDBox sx={{ mt: 8 }}>
              <MDAlert color="error">
                Non hai i permessi per visualizzare questa pagina.
              </MDAlert>
            </MDBox>
          }
        </DashboardLayout>
      );
    }

export default ManagmentSecurityAreaSupplierAdmin;
